import { AppRouteMapInterface } from "../types";
import { lazy } from "react";
import routePath from "./routePaths";

const DashboardContainer = lazy(
	async () => await import("../modules/dashboardAndReports/containers/DashboardContainer")
);
const TransactionHistoryContainer = lazy(
	async () => await import("../modules/transactions/containers/TransactionHistoryContainer")
);
const PendingTransactionsContainer = lazy(
	async () => await import("../modules/transactions/containers/PendingTransactionsContainer")
);
const ReportsContainer = lazy(async () => await import("../modules/dashboardAndReports/containers/ReportsContainer"));

export const routeMap: AppRouteMapInterface = {
	DASHBOARD: {
		menuLabel: "Dashboard",
		component: DashboardContainer,
		path: routePath.DASHBOARD,
	},
	TRANSACTION_HISTORY: {
		menuLabel: "Transactions",
		component: TransactionHistoryContainer,
		path: routePath.TRANSACTION_HISTORY_CONTAINER,
		subMenus: [
			{
				path: routePath.TRANSACTION_HISTORY_CONTAINER,
				menuLabel: "Transaction History",
			},
		],
	},
	PENDING_TRANSACTIONS: {
		menuLabel: "Transactions",
		component: PendingTransactionsContainer,
		path: routePath.PENDING_TRANSACTIONS_CONTAINER,
		subMenus: [
			{
				path: routePath.PENDING_TRANSACTIONS_CONTAINER,
				menuLabel: "Pending Transactions",
			},
		],
	},
	REPORTS: {
		menuLabel: "Reports",
		component: ReportsContainer,
		path: routePath.REPORTS,
	},
};
